import { render, staticRenderFns } from "./order-item-card.vue?vue&type=template&id=c6ef1d24"
import script from "./order-item-card.vue?vue&type=script&lang=js"
export * from "./order-item-card.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports